export default __webpack_public_path__ + "static/media/PendingAdditionalInfoOrangeIcon.ea41a0bf.png";